import BulletPointsCard from '../../BulletPointsCard'
import RightIcon from '../../../Icons/coaching/funnel/right-icon.svg'
import GradientButton from '../../Buttons/GradientButton'

const bulletPoints = [
    {
        title: 'Commission',
        description:
            'Earn 5% on net revenue for all referrals who use your affiliate link.',
        icon: RightIcon,
    },
    {
        title: 'Marketing Assets',
        description:
            'Access banners, logos, pre-written content, and editable Canva templates.',
        icon: RightIcon,
    },
    {
        title: 'Branding Support',
        description:
            'Ensure consistent messaging with our branding guidelines and logos.',
        icon: RightIcon,
    },
    {
        title: 'Dedicated Marketing Coach',
        description: 'Personalized guidance from your designated coach.',
        icon: RightIcon,
    },
]

const AffiliateButton = ({ onApplyClick }) => {
    return <GradientButton onClick={onApplyClick}>Apply Now</GradientButton>
}

const AffiliateButtonSecond = ({ onApplyClick }) => {
    return (
        <div className="w-96 max-w-full">
            <GradientButton onClick={onApplyClick}>
                Apply To Become an Affiliate
            </GradientButton>
        </div>
    )
}

function Benefits(props) {
    const CallActionButton = () => (
        <AffiliateButton onApplyClick={props.onApplyClick} />
    )

    const CallActionButtonTwo = () => (
        <AffiliateButtonSecond onApplyClick={props.onApplyClick} />
    )

    return (
        <div className="bg-light-yellow-gradient py-20 space-y-20 rounded-10xl">
            <BulletPointsCard
                alignment="right"
                title="Affiliate Benefits"
                bulletPoints={bulletPoints}
                bulletSeperateDesc={true}
                bulletColor="olm-green"
                imagePath="/assets/landing/join-affiliate/benefit-1.png"
                mobileImagePath={'/assets/landing/join-affiliate/benefit-1.png'}
                CallActionText="Apply To Become an Affiliate"
                CallActionButton={CallActionButton}
                callAction={false}
                extraCallAction={false}
            />

            <BulletPointsCard
                alignment="left"
                title="Affiliate Resources"
                bulletPoints={bulletPoints}
                bulletSeperateDesc={true}
                bulletColor="olm-green"
                imagePath="/assets/landing/join-affiliate/benefit-2.png"
                mobileImagePath={'/assets/landing/join-affiliate/benefit-2.png'}
                CallActionText="Apply To Become an Affiliate"
                CallActionButton={CallActionButtonTwo}
                callAction={false}
                extraCallAction={false}
            />
        </div>
    )
}

export default Benefits
